"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Lookup
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutListToJSON = exports.PutListFromJSONTyped = exports.PutListFromJSON = void 0;
const _1 = require("./");
function PutListFromJSON(json) {
    return PutListFromJSONTyped(json, false);
}
exports.PutListFromJSON = PutListFromJSON;
function PutListFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': json['category'],
        'description': json['description'],
        'values': (json['values'].map(_1.LookupValueFromJSON)),
    };
}
exports.PutListFromJSONTyped = PutListFromJSONTyped;
function PutListToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': value.category,
        'description': value.description,
        'values': (value.values.map(_1.LookupValueToJSON)),
    };
}
exports.PutListToJSON = PutListToJSON;
//# sourceMappingURL=PutList.js.map